export default "__VITE_ASSET__Pf7e0R1b__"